// 都道府県名の英語表記。data/munis.json の pref は日本語のままで、フィルタ・URL の値も
// 日本語を使い続ける（URL の互換と、原典との照合を壊さないため）。ここは表示だけを差し替える。
// 市区町村名は 1,892 件ぶんの英語表記が一次情報に無いので訳さない（/about に注記あり）。
import type { Lang } from "./i18n";

export const PREF_EN: Record<string, string> = {
  北海道: "Hokkaido",
  青森県: "Aomori",
  岩手県: "Iwate",
  宮城県: "Miyagi",
  秋田県: "Akita",
  山形県: "Yamagata",
  福島県: "Fukushima",
  茨城県: "Ibaraki",
  栃木県: "Tochigi",
  群馬県: "Gunma",
  埼玉県: "Saitama",
  千葉県: "Chiba",
  東京都: "Tokyo",
  神奈川県: "Kanagawa",
  新潟県: "Niigata",
  富山県: "Toyama",
  石川県: "Ishikawa",
  福井県: "Fukui",
  山梨県: "Yamanashi",
  長野県: "Nagano",
  岐阜県: "Gifu",
  静岡県: "Shizuoka",
  愛知県: "Aichi",
  三重県: "Mie",
  滋賀県: "Shiga",
  京都府: "Kyoto",
  大阪府: "Osaka",
  兵庫県: "Hyogo",
  奈良県: "Nara",
  和歌山県: "Wakayama",
  鳥取県: "Tottori",
  島根県: "Shimane",
  岡山県: "Okayama",
  広島県: "Hiroshima",
  山口県: "Yamaguchi",
  徳島県: "Tokushima",
  香川県: "Kagawa",
  愛媛県: "Ehime",
  高知県: "Kochi",
  福岡県: "Fukuoka",
  佐賀県: "Saga",
  長崎県: "Nagasaki",
  熊本県: "Kumamoto",
  大分県: "Oita",
  宮崎県: "Miyazaki",
  鹿児島県: "Kagoshima",
  沖縄県: "Okinawa",
};

/** 表に無い値（データ側の表記ゆれ）は、黙って落とさず日本語のまま出す。 */
export function prefLabel(pref: string, lang: Lang): string {
  if (lang === "ja") return pref;
  return PREF_EN[pref] ?? pref;
}

/** 市区町村の表示名。英語では都道府県だけ英語にし、市区町村名は原語のまま添える。 */
export function muniLabel(pref: string, name: string, lang: Lang): string {
  return lang === "ja" ? `${pref}${name}` : `${prefLabel(pref, lang)} / ${name}`;
}
